export default {"src":"/_next/static/media/trustpilot_half_star.85acaae7.svg","height":15,"width":14};